import React from 'react';
import '../../bootstrap.css';
import LoggedFoodsTableRow from './LoggedFoodsTableRow';
let _ = require('lodash');

export default class LoggedFoodsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      foods: this.props.foods,
      showFoodLoggingForm: false,
    };
  }

  _getFirstTimestamp = (food) => {
    return food.loggedTimestamps ? (food.loggedTimestamps.length > 0 ? food.loggedTimestamps[0].timestamp : 0) : 0;
  }

  render() {
    let sortedFoods = [];
    for (let docId in this.props.foods) {
      let food = this.props.foods[docId];
      food.docId = docId;
      sortedFoods.push(food);
    }
    if (!this.props.ignoreTimestamps) {
      sortedFoods = _.sortBy(sortedFoods, (food) => this._getFirstTimestamp(food));
    }

    return (
      <div>
        <div className='row' style={{ marginBottom: '10px' }}>
          <div className='col-2'><b>{this.props.revisionHistoryTitle ? this.props.revisionHistoryTitle : "History"}</b></div>
          <div className='col-1'><b>Logged Food</b></div>
          <div className='col-1'><b>Serving</b></div>
          <div className='col-1'><b>Calories</b></div>
          <div className='col-1'><b>Carbs</b></div>
          <div className='col-1'><b>Protein</b></div>
          <div className='col-1'><b>Fat</b></div>
          <div className='col-2'><b>Food Groups</b></div>
        </div>
        {

          sortedFoods.map(food => {
            let id = food.docId;
            let revisionHistory = (_.isEmpty(food.revisionHistory) || food.revisionHistory.length < 1) ?
              <span key={id} /> :
              <div key={id}>
                <ol reversed>
                  {
                    food.revisionHistory.toReversed().map(revisionText => {
                      var revisionTextLines = revisionText.split('\n');
                      return <li
                        key={revisionText}
                        style={{ wordWrap: 'break-word' }}
                      >
                        {
                          revisionTextLines.map(revisionLine => {
                            return <div key={revisionLine} dangerouslySetInnerHTML={{ __html: revisionLine }} />;
                          })
                        }
                      </li>
                    })
                  }
                </ol>
              </div>;

            return (
              <LoggedFoodsTableRow
                key={id}
                docId={id}
                targetDate={this.props.targetDate}
                userId={this.props.userId}
                userStatus={this.props.userStatus}
                adminId={this.props.adminId}
                images={food.images}
                revisionHistory={revisionHistory}
                food={food}
                enableDateMigration={this.props.enableDateMigration}
                onDelete={this.props.onDeleteFood}
                onCorrect={this.props.onCorrectFood}
                firstLoggedTimestamp={this._getFirstTimestamp(food)}
                ignoreTimestamps={this.props.ignoreTimestamps}
                isIngredient={this.props.isIngredient}
              />
            )
          })
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/foodLogging/LoggedFoodsTable.js